import script from "./token-code.vue?vue&type=script&setup=true&lang=ts"
export * from "./token-code.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__